export default __webpack_public_path__ + "media/zurb/img/services/services/web-portal-img-71aa7ce029590202e938badc2b18f271.png";